import React, { useState } from "react";
import Image from "../../../elements/Image";
import Modal from "../../../elements/Modal";
import DatePicker from "../../../form/DatePicker";
import TimePicker from "../../../form/timePicker/TimePicker";
import Button from "../../../form/Button";
import {
  addTimeToDate,
  initialsValue,
  parseTimeString,
} from "../../../../helpers";
import Checkbox from "../../../form/Checkbox";
import Indentification from "../../../elements/Indentification";

const ArtistItem = ({
  artist,
  index,
  onSubmit = () => {},
  selectedArtists = [],
}) => {
  const [open, setOpen] = useState(false);
  const [start, setStart] = useState({ date: null, time: "00:00:00 AM" });
  const [end, setEnd] = useState({ date: null, time: "00:00:00 AM" });

  function submit() {
    const startDate = addTimeToDate(start?.date, parseTimeString(start?.time));
    const endDate = addTimeToDate(end?.date, parseTimeString(end?.time));
    onSubmit({ id: artist?.user, startDate, endDate });
  }

  return (
    <>
      <div className="border border-surface-04 rounded-xl overflow-hidden relative">
        <div className="absolute top-2 right-2">
          <Checkbox
            checked={selectedArtists?.includes(artist?.user)}
            onChange={(e) => {
              submit();
            }}
          />
        </div>
        <div className="overflow-hidden h-48">
          <Indentification
            image={artist?.info?.avatarUrl}
            initial={initialsValue(artist?.info?.displayName)}
            alt={artist?.info?.displayName}
            size="full"
            className={"h-full rounded-none"}
            initialStyle={{ fontSize: 50 }}
          />
        </div>
        <div className="p-4 h-[calc(100%-192px)] flex flex-col">
          <div className="space-y-2">
            <h3 className="font-semibold text-lg leading-tight">
              {artist?.info?.displayName}
            </h3>
            {/* <p className="text-muted-foreground text-sm">Pop &amp; Rock</p> */}
          </div>
          {/* <div className="flex justify-between items-center">
            <div className="flex items-center gap-1">
              <i className="fa-solid fa-star text-amber-400"></i>
              <span className="font-medium text-sm mt-1">4.3</span>
            </div>
          </div> */}
          <div className="line-clamp-3 text-sm font-medium text-surface-05 my-3">
            {artist?.info?.profileData}
          </div>
          <button
            onClick={() => {
              //   setOpen(true);
              submit();
            }}
            type="button"
            className="border border-deep-purple text-deep-purple px-3 py-2 rounded-xl w-full font-medium hover:text-primary hover:border-primary mt-auto"
          >
            {selectedArtists?.includes(artist?.user) ? "Unselect" : "Select"}{" "}
            Artist
          </button>
        </div>
      </div>
      <Modal
        isOpen={open}
        setIsOpen={() => {
          setOpen(false);
        }}
        size="xl"
      >
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <DatePicker
              onChange={({ startDate }) =>
                setStart((pre) => ({ ...pre, date: startDate }))
              }
              value={{ startDate: start?.date, endDate: start?.date }}
            />
            <TimePicker
              onChange={(val) => setStart((pre) => ({ ...pre, time: val }))}
              value={start?.time}
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <DatePicker
              onChange={({ startDate }) =>
                setEnd((pre) => ({ ...pre, date: startDate }))
              }
              value={{ startDate: end?.date, endDate: end?.date }}
            />
            <TimePicker
              onChange={(val) => setEnd((pre) => ({ ...pre, time: val }))}
              value={end?.time}
            />
          </div>
          <Button
            buttonLabel={"Select Artist"}
            buttonClasses={"ml-auto"}
            buttonFunction={submit}
          />
        </div>
      </Modal>
    </>
  );
};

export default ArtistItem;
